/* eslint-disable */
/* tslint:disable */
// @ts-ignore
export default {
    width: 16,
    height: 16,
    viewBox: '0 0 48 48',
    data: '<path pid="0" d="M0 44.609l20.638-20.638L.058 3.391 3.449 0l20.58 20.58L44.609 0l3.274 3.333-20.58 20.579L48 44.609 44.667 48 23.971 27.303 3.333 47.942 0 44.609z" fill-rule="nonzero"/>'
}
